import { render, staticRenderFns } from "./audiocmponent.vue?vue&type=template&id=3ba1933c"
import script from "./audiocmponent.vue?vue&type=script&lang=js"
export * from "./audiocmponent.vue?vue&type=script&lang=js"
import style0 from "./audiocmponent.vue?vue&type=style&index=0&id=3ba1933c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports